<!-- eslint-disable vue/no-v-html -->
<template>
  <!-- 컨펌 모달 -->
  <div
    class="modal-wrapper type-alert confirm-modal"
    :class="{ 'is-show': confirmPopup.isPopupVisible }"
  >
    <span class="bg-cover" @click="confirmPopup.onCancel()" />
    <div class="dialog-modal modal type-confirm">
      <div class="modal-wrap">
        <div class="dialog-content modal-cont is-show">
          <p class="dialog-tt modal-cont-ttl">
            {{ confirmPopup.title }}
          </p>
          <p v-if="confirmPopup.desc !== ''" class="dialog-txt modal-cont-txt">
            {{ confirmPopup.desc }}
          </p>
        </div>
        <div v-if="confirmPopup.message !== ''" class="grp mt-34">
          <input id="m_agree01" type="checkbox" class="is-none toggle-switch" />
          <label for="m_agree01" class="label-chk-03">{{
            confirmPopup.message
          }}</label>
        </div>
        <div class="dialog-button btn-grp type-agree">
          <button
            type="button"
            class="btn btn-full btn-dialog btn-confirm-modal"
            @click="confirmPopup.onConfirm"
          >
            {{ confirmPopup.yes }}
          </button>
          <button
            type="button"
            class="btn btn-full btn-dialog btn-confirm-modal btn-cancel"
            @click="confirmPopup.onCancel"
          >
            {{ confirmPopup.no }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmDialog",
  data() {
    return {
      isShowModal: false,
    };
  },
};
</script>

<style scoped></style>
